import { c as _c } from "react/compiler-runtime";
import { Block } from "common/types/graphql";
import { TextLink } from "common/components/TextLink";
import { isValidUrl } from "common/lib/isValidUrl";
import { BlocksRenderer } from "../BlocksRenderer";
export interface LinkProps {
  blocks?: Block[];
  text?: string;
  url: string;
}
export const Link = t0 => {
  "use memo";

  const $ = _c(6);
  const {
    blocks,
    text,
    url
  } = t0;
  const t1 = isValidUrl(url) ? url : undefined;
  let t2;
  if ($[0] !== blocks) {
    t2 = blocks && <BlocksRenderer blocks={blocks} />;
    $[0] = blocks;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== text) {
    t3 = <TextLink href={t1}>{text}{t2}</TextLink>;
    $[2] = t1;
    $[3] = t2;
    $[4] = text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};